/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class GovernanceConfigurationForPolicyAzure extends models.GovernanceConfigurationBaseForPolicy {
    constructor() {
        super();
        this.setDiscriminator("GovernanceConfigurationForPolicyAzure");
    }

    getFixupPrototypeFunction() { return GovernanceConfigurationForPolicyAzure.fixupPrototype; }

    static newInstance(model: Partial<GovernanceConfigurationForPolicyAzure>): GovernanceConfigurationForPolicyAzure {
        let obj = Object.assign(new GovernanceConfigurationForPolicyAzure(), model);
        GovernanceConfigurationForPolicyAzure.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<GovernanceConfigurationForPolicyAzure>): GovernanceConfigurationForPolicyAzure {
        if (!model) return null;
        return GovernanceConfigurationForPolicyAzure.newInstance(<GovernanceConfigurationForPolicyAzure> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: GovernanceConfigurationForPolicyAzure) {
        if (!obj) return;

        models.GovernanceConfigurationForPolicyAzure.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: GovernanceConfigurationForPolicyAzure): boolean {
        if (models.GovernanceConfigurationBaseForPolicy.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, GovernanceConfigurationForPolicyAzure.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
